import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CompanyAsyncExportServiceModel } from '../../../../shared/components';
import { SalesforceGeneralSettingsDto, SettingsResponse } from '../../../../shared/dto';
import { OfflineExportsCrmExportTypesEnum } from '../../../../shared/enums';
import { SalesforceApiService } from '../../../../shared/services/api';

@Injectable()
export class CompanySFAsyncExportService implements CompanyAsyncExportServiceModel {
    crmType: OfflineExportsCrmExportTypesEnum = OfflineExportsCrmExportTypesEnum.SALESFORCE;

    constructor(private readonly salesforceApiService: SalesforceApiService) {
    }

    getSettingsDuplicateResolution(): Observable<string> {
        return this.salesforceApiService.getSettings()
            .pipe(map((response: SettingsResponse<SalesforceGeneralSettingsDto>) => response.general.sfDuplicateResolution));
    }
}
